import {
  ChangeDetectorRef,
  HostListener,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';

import * as _moment from 'moment';

import { trigger, state, style, transition, animate } from '@angular/animations';

import { MatDialog } from '@angular/material/dialog';
import { AppModalFooterManagementComponent } from './component/app-model-edit-footer/app-modal-edit-footer.component';
import { SystemSettingService } from '@app/api/systemsettting.service';
import { switchMap, map } from 'rxjs/operators';
import { forkJoin, of, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

interface system {
  id?: string;
  type?: string;
  name?: string | null;
  value?: string | null;
  description?: string | null;
  created_at?: string;
  created_by?: string;
  modified_at?: string | null;
  modified_by?: string | null;
  is_hidden?: boolean;
  sort_order?: number;
  parent_id?: string | null;
  parent_title?: string | null;
  page_location?: string;
  slug?: string | null;
  language?: 'vi' | 'en' | 'zh' | string;
}

@Component({
  selector: 'footer-management.component',
  templateUrl: './footer-management.component.html',
  styleUrls: ['./footer-management.component.scss'],
  // animations: [
  //   trigger('expand', [
  //     state(
  //       'closed',
  //       style({
  //         transform: 'scaleY(0)',
  //         opacity: 0,
  //         transformOrigin: 'top',
  //         overflow: 'hidden',
  //       })
  //     ),
  //     state(
  //       'open',
  //       style({
  //         transform: 'scaleY(1)',
  //         opacity: 1,
  //         transformOrigin: 'top',
  //       })
  //     ),
  //     transition('closed <=> open', animate('150ms ease')),
  //   ]),
  // ],
})
export class AppFooterManagementComponent implements OnInit {
  lstGroupVi: any = { children: [] };
  lstGroupEn: any = { children: [] };
  lstGroupZh: any = { children: [] };
  openMenuId: string | null = null;

  // Thay đổi từ string sang Set để lưu nhiều id
  openChildIds: Set<string> = new Set();

  typeFooter = {
    vi: 'FOOTER-VN',
    en: 'FOOTER-EN',
    zh: 'FOOTER-ZH',
  };
  idVi: string;
  idEn: string;
  idZh: string;

  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    private system: SystemSettingService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    forkJoin([
      this.getGroupByType(this.typeFooter.vi),
      this.getGroupByType(this.typeFooter.en),
      this.getGroupByType(this.typeFooter.zh),
    ]).subscribe(([dataVi, dataEn, dataZh]) => {
      this.lstGroupVi = dataVi;
   
      this.lstGroupEn = dataEn;
      this.lstGroupZh = dataZh;
    });

    forkJoin([
      this.createMainGroup(this.typeFooter.vi, 'vi'),
      this.createMainGroup(this.typeFooter.en, 'en'),
      this.createMainGroup(this.typeFooter.zh, 'zh'),
    ]).subscribe(([idVi, idEn, idZh]) => {
      this.idVi = idVi;
      this.idEn = idEn;
      this.idZh = idZh;


    });
  }
  onTabChange(event: any) {
    // Tạo Set mới thay vì clear
    this.openChildIds = new Set();
    this.openMenuId = null;

    // Load data cho tab được chọn
    const tabIndex = event.index;
    if (tabIndex === 1 && !this.lstGroupEn) {
      // English tab
      this.getGroupByType(this.typeFooter.en).subscribe((data) => {
        this.lstGroupEn = data;
      });
    } else if (tabIndex === 2 && !this.lstGroupZh) {
      // Chinese tab
      this.getGroupByType(this.typeFooter.zh).subscribe((data) => {
        this.lstGroupZh = data;
      });
    }

    // Force Angular detect changes
    this.cdr.detectChanges();
  }
  // Sửa lại hàm openChild để xử lý nhiều child độc lập
  openChild(id: string, el: HTMLElement) {
    const isOpen = this.openChildIds.has(id);

    if (isOpen) {
      // Đóng
      el.style.height = el.scrollHeight + 'px';
      requestAnimationFrame(() => {
        el.style.height = '0px';
      });
      this.openChildIds.delete(id);
    } else {
      // Mở
      this.openChildIds.add(id);

      el.style.height = 'auto';
      const height = el.scrollHeight;
      el.style.height = '0px';

      requestAnimationFrame(() => {
        el.style.height = height + 'px';
      });
    }
  }

  // Thêm helper method để check trạng thái
  isChildOpen(id: string): boolean {
    return this.openChildIds.has(id);
  }

  @ViewChild('containerRef', { static: false })
  containerRef!: ElementRef<HTMLElement>;

  toggleMenu(event: MouseEvent, id: string) {
    event.stopPropagation();
    this.openMenuId = this.openMenuId === id ? null : id;
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: MouseEvent) {
    if (
      this.openMenuId &&
      this.containerRef &&
      !this.containerRef.nativeElement.contains(event.target as Node)
    ) {
      this.openMenuId = null;
    }
  }

  getGroupByType(type): Observable<any[]> {
    return this.system
      .apiSystemSettingGet(`type==${type}`)
      .pipe(map((res) => res.data.collection[0]));
  }
  handleEditRequest(event: { title: string; type: string; id: any; lang: string }) {

    this.openEditModal(event.title, event.type, event.id, event.lang as 'vi' | 'en' | 'zh');
  }

  handleDelete(event: { item: any; type: string }) {


    if (confirm('Bạn có chắc muốn xóa?')) {

      this.system.apiSystemSettingIdDelete(event.item.id).subscribe(
        (res) => {
       
          if (res.success) {
            this.toastr.success('Xóa thành công');
            // Reload data based on lang
            const lang = event.item.language || 'vi';
        
            if (lang === 'vi') {
              this.getGroupByType(this.typeFooter.vi).subscribe((data) => {
                this.lstGroupVi = data;
                this.cdr.detectChanges();
              });
            } else if (lang === 'en') {
              this.getGroupByType(this.typeFooter.en).subscribe((data) => {
                this.lstGroupEn = data;
                this.cdr.detectChanges();
              });
            } else {
              this.getGroupByType(this.typeFooter.zh).subscribe((data) => {
                this.lstGroupZh = data;
                this.cdr.detectChanges();
              });
            }
          } else {
            this.toastr.error('Xóa thất bại');
          }
        },
        (error) => {
       
          this.toastr.error('Có lỗi xảy ra khi xóa');
        }
      );
    } else {
  
    }
  }

  openEditModal(title, type, id?, lang?: 'vi' | 'en' | 'zh') {
   
    const dialogRef = this.dialog.open(AppModalFooterManagementComponent, {
      width: '400px',
      data: { title, type, id, lang },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result && result.success) {
  
        this.toastr.success(
          result.type && result.type.includes('update') ? 'Cập nhật thành công' : 'Tạo thành công'
        );

        if (result.lang === 'vi') {
          this.getGroupByType(this.typeFooter.vi).subscribe((data) => {
       
            this.lstGroupVi = data;
            this.cdr.detectChanges(); // Force immediate render
      
          });
        } else if (result.lang === 'en') {
          this.getGroupByType(this.typeFooter.en).subscribe((data) => {
    
            this.lstGroupEn = data;
            this.cdr.detectChanges(); // Force immediate render
          });
        } else {
          this.getGroupByType(this.typeFooter.zh).subscribe((data) => {
        
            this.lstGroupZh = data;
            this.cdr.detectChanges(); // Force immediate render
          });
        }
      } else {
        this.toastr.error('Thao tác thất bại');
      }
    });
  }

  createMainGroup(type, lang) {
    const obj = {
      type: type,
      is_hidden: false,
      page_location: 'FOOTER',
      language: lang,
    };
    return this.system.apiSystemSettingGetParentTypeGet(`type==${type}`).pipe(
      switchMap((res) => {
        return res.data.collection.length === 0
          ? this.system.apiSystemSettingPost(obj).pipe(map((res) => res.data.id))
          : of(res.data.collection[0].id);
      })
    );
  }
}
